module.exports = __webpack_public_path__ + "img/new-indication.f7807789.svg";